import { useState, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import { useParams, useHistory } from "react-router-dom";
import VehicleCard from "../VehicleCard";
import React from "react";
import { Link as Linkscroll } from "react-scroll";
import useFinanciaciones from "../../config/useFinanciaciones";
import FinancingCarousel from "./FinancingCarousel";
import loading from "../../assets/loading.svg";

const VehicleList = ({ vehicles }) => {
  const [tipoSearch, setTipoSearch] = useState("todos");
  const [tipoToUse, setTipoToUse] = useState("todos");
  const [filtrados, setFiltrados] = useState(vehicles);

  let history = useHistory();
  let { tipo } = useParams();

  const { financiaciones, loading: loadingFinanciaciones } = useFinanciaciones();

  useEffect(() => {
    if (
      tipo === undefined ||
      (tipo !== "todos" && tipo !== "convencional" && tipo !== "plan" && tipo !== "preventa" && tipo !== "adjudicados")
    ) {
      setTipoToUse("todos");
      handleTipo("todos");
    } else {
      setTipoToUse(tipo);
      handleTipo(tipo);
    }
  }, [tipo]);

  useEffect(() => {
    setTipoSearch(tipoToUse);
  }, [tipoToUse]);

  const handleTipo = (e) => {
    setTipoSearch(e);
    console.log("aca", e);
    history.push(`/${e}`);
  };

  //FILTRAR LOS VEHICULOS
  useEffect(() => {
    if (tipoSearch === "adjudicados") {
      setFiltrados(vehicles.filter((item) => item.adjudicado?.habilitado === true));
    }

    if (tipoSearch === "preventa") {
      setFiltrados(vehicles.filter((item) => item.preventa.habilitado === true));
    }

    if (tipoSearch === "plan") {
      setFiltrados(vehicles.filter((item) => item.plan.habilitado === true));
    }

    if (tipoSearch === "convencional") {
      setFiltrados(vehicles.filter((item) => item.convencional.habilitado === true));
    }

    if (tipoSearch === "todos") {
      setFiltrados(vehicles);
    }
  }, [tipoSearch, vehicles]);

  const filtradosPreventa = vehicles.filter((item) => item.preventa?.habilitado === true);

  const filtradosConvencional = vehicles.filter((item) => item.convencional?.habilitado === true);

  const filtradosPlan = vehicles.filter((item) => item.plan?.habilitado === true);

  const filtradosAdjudicados = vehicles.filter((item) => item?.adjudicado?.habilitado === true);

  // aqui guardamos los datos de utms

  /* localStorage.setItem('saludo', 'Bienvenidos a localStorage');
  valor = localStorage.getItem('saludo');
  */ //console.log(filtradosPreventa);

  return (
    <>
      <Row id="scroll-click">
        <Col md={12} className="text-center">
          <h1 className="titMainPortada pt-5 pb-5 text-center">Subite a tu 0km en Montironi Jeep</h1>
        </Col>
      </Row>

      <Row className="pb-5" id="todos">
        <Col className="d-flex justify-content-center">
          <Linkscroll
            to="scroll-click"
            className={`btn btn-blue m-2 ${
              tipoSearch !== "plan" &&
              tipoSearch !== "convencional" &&
              tipoSearch !== "preventa" &&
              tipoSearch !== "adjudicados" &&
              "active"
            }`}
            onClick={() => handleTipo("todos")}
          >
            Ver todo
          </Linkscroll>
          {filtradosPreventa && filtradosPreventa.length > 0 && (
            <Linkscroll
              className={`btn btn-blue m-2 ${tipoSearch === "preventa" && "active"}`}
              onClick={() => handleTipo("preventa")}
              to="scroll-click"
            >
              Preventa
            </Linkscroll>
          )}
          <Linkscroll
            className={`btn btn-blue m-2 ${tipoSearch === "convencional" && "active"}`}
            onClick={() => handleTipo("convencional")}
            to="scroll-click"
          >
            0 KM
          </Linkscroll>
          <Linkscroll
            className={`btn btn-blue m-2 ${tipoSearch === "plan" && "active"}`}
            onClick={() => handleTipo("plan")}
            to="scroll-click"
          >
            Plan de Ahorro
          </Linkscroll>
          {filtradosAdjudicados && filtradosAdjudicados.length > 0 && (
            <Linkscroll
              className={`btn btn-blue m-2 ${tipoSearch === "adjudicados" && "active"}`}
              onClick={() => handleTipo("adjudicados")}
              to="scroll-click"
            >
              Adjudicados
            </Linkscroll>
          )}
        </Col>
      </Row>
      {(tipoSearch === "preventa" || tipoSearch === "todos") && filtradosPreventa && filtradosPreventa.length > 0 ? (
        <div className={tipoSearch === "plan" ? null : "mt-5"} id="plan">
          <Row className="d-flex">
            <h2 className="titulo-categorias-home">JEEP PREVENTA</h2>
          </Row>
          <Row className="d-flex">
            {filtradosPreventa && filtradosPreventa.length > 0 ? (
              filtradosPreventa
                .sort((a, b) => b.preventa.prioridad - a.preventa.prioridad)
                .map((item, index) => (
                  <Col lg={4} md={6} xs={12} key={index} className="flex-wrap mb-4">
                    <VehicleCard
                      info={item}
                      tipo={tipoSearch}
                      filtrados={filtradosPreventa}
                      nombreTipo="preventa"
                      todosLosVehiculos={vehicles}
                    />
                  </Col>
                ))
            ) : (
              <>
                <p className="text-center pt-5 pb-5">Proximamente más opciones disponibles.</p>
              </>
            )}
          </Row>
        </div>
      ) : null}

      {tipoSearch === "convencional" || tipoSearch === "todos" ? (
        <div id="convencional">
          <Row className="d-flex">
            <h2 className="titulo-categorias-home">VENTA DIRECTA</h2>
          </Row>
          <Row>
            <Col>
              {loadingFinanciaciones ? (
                <Row className="d-flex justify-content-center mb-5">
                  <img src={loading} alt="Cargando..." style={{ width: 100, height: 100 }} />
                </Row>
              ) : financiaciones && financiaciones.length > 0 ? (
                <FinancingCarousel financiaciones={financiaciones} />
              ) : null}
            </Col>
          </Row>
          <Row className="d-flex">
            {filtradosConvencional && filtradosConvencional.length > 0 ? (
              filtradosConvencional
                .sort((a, b) => b.convencional.prioridad - a.convencional.prioridad)
                .map((item, index) => (
                  <Col lg={4} md={6} xs={12} key={index} className="flex-wrap mb-4">
                    <VehicleCard
                      info={item}
                      tipo={tipoSearch}
                      filtrados={filtradosConvencional}
                      nombreTipo="convencional"
                      todosLosVehiculos={vehicles}
                    />
                  </Col>
                ))
            ) : (
              <>
                <p className="text-center pt-5 pb-5">Proximamente más opciones disponibles.</p>
              </>
            )}
          </Row>
        </div>
      ) : null}

      {tipoSearch === "plan" || tipoSearch === "todos" ? (
        <div className={tipoSearch === "plan" ? null : "mt-5"} id="plan">
          <Row className="d-flex">
            <h2 className="titulo-categorias-home">JEEP PLAN</h2>
          </Row>
          <Row className="d-flex">
            {filtradosPlan && filtradosPlan.length > 0 ? (
              filtradosPlan
                .sort((a, b) => b.plan.prioridad - a.plan.prioridad)
                .map((item, index) => (
                  <Col lg={4} md={6} xs={12} key={index} className="flex-wrap mb-4">
                    <VehicleCard
                      info={item}
                      tipo={tipoSearch}
                      filtrados={filtradosPlan}
                      nombreTipo="plan"
                      todosLosVehiculos={vehicles}
                    />
                  </Col>
                ))
            ) : (
              <>
                <p className="text-center pt-5 pb-5">Proximamente más opciones disponibles.</p>
              </>
            )}
          </Row>
        </div>
      ) : null}

      {tipoSearch === "adjudicados" || tipoSearch === "todos" ? (
        <div className={tipoSearch === "plan" ? null : "mt-5"} id="plan">
          {filtradosAdjudicados && filtradosAdjudicados.length > 0 ? (
            <>
              {" "}
              <Row className="d-flex">
                <h2 className="titulo-categorias-home">PLANES ADJUDICADOS</h2>
              </Row>
              <Row className="d-flex">
                {filtradosAdjudicados
                  .sort((a, b) => a.adjudicado.prioridad - b.adjudicado.prioridad)
                  .map((item, index) => (
                    <Col lg={4} md={6} xs={12} key={index} className="flex-wrap mb-4">
                      <VehicleCard
                        info={item}
                        tipo={tipoSearch}
                        filtrados={filtradosAdjudicados}
                        nombreTipo="adjudicado"
                        todosLosVehiculos={vehicles}
                      />
                    </Col>
                  ))}
              </Row>
            </>
          ) : null}
        </div>
      ) : null}
    </>
  );
};

export default VehicleList;

